<template>
  <!-- 报名成功弹窗 -->
  <van-popup v-model="showImg" class="transparent-popup">
    <div class="v-pop-success">
      <div class="content" @click="close">
        <div class="btn-close"></div>
        <div
          v-if="superInfo.activityCategory !== 2"
          class="time-icon time-icon02"
        ></div>
        <div v-else class="time-icon time-icon01"></div>
        <div class="time">
          <sapn class="t1">{{ drawStartTimeYymmdd }}</sapn>
          <sapn class="t2">{{ drawStartTimeHhmm }}</sapn>
        </div>
        <div v-if="superInfo.activityCategory !== 2" class="text">
          若有中奖用户未在【兑奖时间】即开奖后10分钟内进行中奖确认，则视为放弃本次中奖，为避免错过请留意短信提醒消息
        </div>
        <div v-else class="text">
          最终排名以公示锁定时系统数据为准，接之前的高并发可能导致投票延迟或失败，相关争议不予处理，请勿压线参与。
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Popup as VanPopup } from "vant";
import { formatDate } from "@utils/utils";

export default {
  name: "VPopImg",

  components: {
    VanPopup,
  },

  props: {
    superInfo: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      // 展示弹窗
      showImg: false,
      drawStartTimeYymmdd: formatDate(this.superInfo.drawStartTime, "yymmdd"),
      drawStartTimeHhmm: formatDate(this.superInfo.drawStartTime, "hhmm"),
    };
  },

  methods: {
    // 显示弹窗
    open() {
      this.showImg = true;
    },
    // 关闭弹窗
    close() {
      this.showImg = false;
    },
  },
};
</script>

<style lang="less" scoped>
// 弹窗背景透明
.transparent-popup {
  background-color: transparent !important;
}
//  报名成功弹窗
.v-pop-success {
  position: relative;
  width: 282px;
  .pop-title {
    padding: 10px 16px;
    text-align: center;
    font-weight: 500;
    font-size: 21px;
    color: #001a33;
    font-family: Arial, Helvetica, sans-serif;
    font-style: normal;
  }
  .content {
    position: relative;
    width: 282px;
    height: 369px;
    margin: 0 auto;
    padding-bottom: 110px;
    padding-top: 160px;
    box-sizing: border-box;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #474747;
    text-align: center;
    background: #fff;
    border-radius: 26px;
    background-image: url("../assets/image/bg-pop-success.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center top;

    .btn-close {
      position: absolute;
      top: 15px;
      right: 15px;
      width: 22px;
      height: 22px;
      background-image: url("../assets/image/icon-pop-close.png");
      background-repeat: no-repeat;
      background-size: 100% auto;
      background-position: center top;
    }
    .time-icon {
      position: absolute;
      top: 115px;
      right: 14px;
      width: 48px;
      height: 48px;
      background-repeat: no-repeat;
      background-size: 100% auto;
      background-position: center top;
    }
    .time-icon01 {
      background-image: url("../assets/image/icon-pop-tips01.png");
    }
    .time-icon02 {
      background-image: url("../assets/image/icon-pop-tips02.png");
    }
    .time {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 203px;
      margin: 0 auto;
      margin-bottom: 22px;
      .t1 {
        font-weight: 600;
        font-size: 23px;
        color: #000000;
      }
      .t2 {
        margin-left: 8px;
        font-weight: 400;
        font-size: 19px;
        color: #000000;
      }
    }
    .text {
      width: 203px;
      margin: 0 auto;
      font-weight: 400;
      font-size: 11px;
      color: rgba(0, 26, 51, 0.6);
      text-align: left;
    }
  }
}
</style>
